import { write, utils } from 'xlsx';

export function eachObj(obj, cb) {
  Object.entries(obj).forEach(([key, val]) => {
    cb(key, obj[key]);
  });
}

export function isPlainObj(target) {
  return Object.prototype.toString.call(target) === '[object Object]';
}

export function merge(target, source, option = { replace: false }) {
  eachObj(source, (key, val) => {
    if (!target[key]) {
      // 如果目标值没有直接新增
      target[key] = val;
      return;
    }
    if (target[key]) {
      if (isPlainObj(target[key]) && isPlainObj(val)) {
        // 如果需要合并的2个值 都为对象
        if (option.replace) {
          target[key] = val;
          return;
        }
        merge(target[key], val);

        return;
      }

      if (!isPlainObj(target[key]) || !isPlainObj(val)) {
        // target[key] 和  val 其中有一个不是对象 直接覆盖
        target[key] = val;
      }
    }
  });
  return target;
}

export function createMapOfArrayByProp(arr = [], prop, repeat = 'first') {
  const map = new Map();
  if (prop) {
    arr.forEach((item) => {
      if (repeat === 'first' && map.get(item[prop])) {
        // 如果指定重复元素的第一个, 并且已经存在 直接return
        return;
      }
      map.set(item[prop], item);
    });
  }
  return map;
}

export function arrayRemoveRepeatByProp(arr = [], prop, repeat = 'first') {
  let result = [];
  if (!prop) {
    result = [...new Set(arr)];
  } else {
    const map = createMapOfArrayByProp(arr, prop, repeat);
    result = [...map.values()];
  }

  return result;
}

export function jsonStringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    console.error('JSON.stringify() error:', obj);
    return obj;
  }
}

export function validImgSize(file, width, height) {
  return new Promise((res) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e) => {
      let src = e.target.result;
      let img = new Image();
      img.src = src;
      img.onload = () => {
        res(img.width === width && img.height === height);
      };
    };
  });
}

function strToBuff(str) {
  const buf = new ArrayBuffer(str.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== str.length; ++i) {
    // eslint-disable-next-line no-bitwise
    view[i] = str.charCodeAt(i) & 0xff;
  }
  return buf;
}

function transformExcelDataToBlob(sheetMap) {
  const workbook = { SheetNames: [], Sheets: {} };
  eachObj(sheetMap, (sheetName, sheetData) => {
    workbook.SheetNames.push(sheetName);
    workbook.Sheets[sheetName] = sheetData;
  });
  const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
  const wbout = write(workbook, wopts);
  const blob = new Blob([strToBuff(wbout)], { type: 'application/octet-stream' });
  return blob;
}

function download(url = '', fileName = '下载文件.xlsx') {
  let href = url;
  if (typeof url === 'object' && url instanceof Blob) {
    href = URL.createObjectURL(url);
  }
  const aLink = document.createElement('a');
  aLink.href = href;
  aLink.download = fileName;
  let event;
  if (window.MouseEvent) {
    event = new MouseEvent('click');
  } else {
    event = document.createEvent('MouseEvents');
    event.initMouseEvent(
      'click',
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
  }
  aLink.dispatchEvent(event);
}

export function exportExcel(
  option = {
    data: [],
    fileName: '',
    sheetName: 'sheet'
  }
) {
  // const data = [
  //     ['姓名', '性别', '年龄', '注册时间'],
  //     ['张三', '男', 18, new Date()],
  //     ['李四', '女', 22, new Date()]
  // ];
  // ------------------------------------
  // const data = {
  //   "sheet1": [
  //     ['姓名', '性别', '年龄', '注册时间'],
  //     ['张三', '男', 18, new Date()],
  //     ['李四', '女', 22, new Date()]
  //   ],
  //   "sheet2": [
  //     ['姓名', '性别', '年龄', '注册时间'],
  //     ['张三', '男', 18, new Date()],
  //     ['李四', '女', 22, new Date()]
  //   ]
  // };
  let { data, fileName, sheetName } = option;
  sheetName = sheetName || 'sheet';
  const sheetDataMap = {};
  if (Array.isArray(data)) {
    // 只有一个sheet

    sheetDataMap[sheetName] = utils.aoa_to_sheet(data);
  } else {
    // 多个sheet 后期有需求拓展
    eachObj(sheetDataMap, (key, dataList) => {
      sheetMap[key] = utils.aoa_to_sheet(dataList);
    });
  }
  download(transformExcelDataToBlob(sheetDataMap), fileName);
}

export function isNullOrDefined(v) {
  return v === undefined || v === null;
}
